
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/articles/planning-a-move-guide",
      function () {
        return require("private-next-pages/articles/planning-a-move-guide.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/articles/planning-a-move-guide"])
      });
    }
  